export default function PageLoader() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-green-950 text-white">
      <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin mb-4"></div>
      <p className="text-sm tracking-wide text-gray-400 italic">
        Preparing your escape to Munroe Island...
      </p>
    </div>
  );
}
